import { render, staticRenderFns } from "./permision.vue?vue&type=template&id=25f76f87&scoped=true&"
import script from "./permision.vue?vue&type=script&lang=ts&"
export * from "./permision.vue?vue&type=script&lang=ts&"
import style0 from "./permision.vue?vue&type=style&index=0&id=25f76f87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f76f87",
  null
  
)

export default component.exports